import { faAngleDown } from "@jewlr/pro-regular-svg-icons/faAngleDown"
import { faAngleUp } from "@jewlr/pro-regular-svg-icons/faAngleUp"
import { motion } from "framer-motion"
import PropTypes from "prop-types"
import React, { useState } from "react"
import styled from "styled-components"

import Typography from "components/common/typography"
import FontAwesomeIcon from "components/font-awesome-icon"

import WhyContent from "./why_choose_jewlr-content"

const Container = styled.div`
  border-bottom: 1px solid ${(props) => props.theme.colors.grey[10]};
  :last-child {
    border-bottom: none;
  }
`
const Heading = styled.div`
  align-items: center;
  cursor: pointer;
  display: flex;
  font-size: ${(props) => props.theme.fontSizes[24]};
  justify-content: space-between;
  line-height: normal;
  padding: ${(props) => `${props.theme.space[3]} ${props.theme.space[2]}`};
`
const Content = styled(motion.div).attrs(() => ({
  initial: "hide",
  transition: {
    type: "linear",
  },
  variants: {
    hide: {
      fontWeight: "light",
      height: 0,
      transitionEnd: { display: "none", overflow: "hidden", paddingBottom: 0 },
    },
    show: {
      display: "block",
      fontWeight: "light",
      height: "auto",
    },
  },
}))`
  display: none;
`
const ReasonsCount = styled.span`
  color: $jewlr-blue;
  float: left;
  font-size: 2em;
  font-weight: normal;
  line-height: 1;
  margin-top: -4px;
  ${(props) => props.theme.mediaQueries.tablet`
    margin: 0 15px 0 20px;
    font-size: 2em;
  `}
`
const Whydropdown = ({ whyCategory, index }) => {
  const [show, setShow] = useState(false)
  return (
    <Container>
      <Heading
        onClick={(e) => {
          e.stopPropagation
          setShow(!show)
        }}
      >
        <Typography
          color="primary"
          fontSize={{ _: 16, tablet: 18 }}
          fontWeight={{ tablet: "300" }}
        >
          <ReasonsCount>{index + 1} &nbsp;</ReasonsCount>
          {whyCategory.title}
        </Typography>
        <FontAwesomeIcon
          color="#4268ff"
          icon={show ? faAngleUp : faAngleDown}
        />
      </Heading>
      <Content animate={show ? "show" : "hide"}>
        {whyCategory.why.map((q, i) => (
          <WhyContent key={`whycontent${i}`} why={q} />
        ))}
      </Content>
    </Container>
  )
}

Whydropdown.propTypes = {
  index: PropTypes.number,
  whyCategory: PropTypes.object,
}

export default Whydropdown
